import { createContext, useContext } from 'react'

export interface AlertBannerState {
  message: string | null
  severity: 'error' | 'info' | 'warning' | 'success'
}

export interface AlertBannerContextValue {
  banner: AlertBannerState
  bannerHeight: number
  showBanner: (message: string, severity?: AlertBannerState['severity']) => void
  hideBanner: () => void
}

export const AlertBannerContext = createContext<AlertBannerContextValue | null>(null)

export function useAlertBanner(): AlertBannerContextValue {
  const context = useContext(AlertBannerContext)
  if (!context) {
    throw new Error('useAlertBanner must be used within an AlertBannerProvider')
  }
  return context
}
